export default (value) => {
  if (!value) return ''
  const date = new Date(value)
  const uxDate = new Date('1970-01-01T00:00:00')
  if (date < uxDate) return ''
  var options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  }
  return new Intl.DateTimeFormat(window.navigator.language, options).format(date)
}
